export const APP_CONFIG = {
  name: "WICSSend",
  version: import.meta.env.CE_VERSION ?? "1.0.0",
  build: {
    number: import.meta.env.BUILD_NUMBER ?? "dev",
    date: import.meta.env.BUILD_DATE ?? new Date().toISOString(),
    revision: import.meta.env.GIT_REVISION ?? "local",
  },
  license: "Enterprise",
  support: {
    url: "https://wics.atlassian.net/servicedesk/customer/portals",
  },
  copyright: {
    year: new Date().getFullYear(),
    company: "Your Company",
  },
} as const;
